export const pageSizeList = [{ key: 10, value: '10 / сторінці'}, { key: 20, value: '20 / сторінці'}, { key: 50, value: '50 / сторінці'}, { key: 100, value: '100 / сторінці'}];
